import { ItemTypeValue } from "zen-core-elements/src/elements/zenDropdown/dropdownPicker";
import { addReadyMadeProductPayload, CreateReadyMadeProductResponse, PayloadProps, ProductCatalogByIndustryResponse, ProductCatalogCategoriesResponse, ProductCatalogItem } from "../../components/products/productList/readymateProducts/readymadeProducts.model";
import { config } from "../../shared/environment";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";


interface initialData {
    loading: boolean,
    posReadymadeProduct: { value: ProductCatalogItem[] | null, loading: boolean, error: string, count?: number },
    categoryData: {
        value: ProductCatalogCategoriesResponse | null, loading: boolean, error: string, dropdownData: ItemTypeValue[]
    }
    error: string,
}

const initialState: initialData = {
    loading: false,
    posReadymadeProduct: { value: null, error: "", loading: true, count: 0 },
    error: '',
    categoryData: {
        value: null,
        error: "",
        loading: true,
        dropdownData: []
    }
}

//to fetch all product catalog data
export const getAllProductCatalog = createAsyncThunk("product/getAllProductCatalog", ({ data, storeId }: { data: PayloadProps, storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl('stores/{storeId}/products/readyMade', { storeId })
    return HttpRoutingService.getMethod<ProductCatalogByIndustryResponse>(url, data)
})

export const addReadyMadeProduct = createAsyncThunk("product/addReadyMadeProduct", (data: addReadyMadeProductPayload[]) => {
    return HttpRoutingService.postMethod<CreateReadyMadeProductResponse>("productCatalog/industryProducts", data, {}, "v1/")
})

//Getting all product categories using getAllCategoriesNameForPosRedux api call using createAsyncThunk
export const getAllCategoriesNameForPosRedux = createAsyncThunk('readymadeProductSlice/getAllCategoriesNameForPos', (({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl('stores/{storeId}/categories', { storeId: storeId })
    return HttpRoutingService?.getMethod<ProductCatalogCategoriesResponse>(url, {})
}))

export const ReadymadeProductSlice = createSlice({
    name: 'readymateProducts',
    initialState: initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(getAllProductCatalog?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getAllProductCatalog?.fulfilled, (state, action) => {
            const { data: { offset } } = action.meta.arg

            const rowsWithSelection =
                action?.payload?.readyMadeProduct?.rows?.map(item => ({
                    ...item,
                    isSelected: false,
                })) || [];

            state.posReadymadeProduct.count = action?.payload?.readyMadeProduct?.count;

            if (offset > 0) {
                state.posReadymadeProduct.value = [
                    ...state.posReadymadeProduct?.value!,
                    ...rowsWithSelection,
                ];
            } else {
                state.posReadymadeProduct.value = rowsWithSelection;
            }
        })
        builder.addCase(getAllProductCatalog?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in getAllProductCatalog'
        })

        builder.addCase(getAllCategoriesNameForPosRedux?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(getAllCategoriesNameForPosRedux?.fulfilled, (state, action: PayloadAction<ProductCatalogCategoriesResponse>) => {
            state.loading = false
            state.categoryData.value = action?.payload
            state.categoryData.dropdownData = action?.payload?.categories?.rows?.map(item => ({
                label: item?.categoryName,
                value: item?.id,
            })) || []
        })
        builder.addCase(getAllCategoriesNameForPosRedux?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in ProductCatalogCategoriesResponse'
        })

        builder.addCase(addReadyMadeProduct?.pending, (state) => {
            state.loading = true
        })
        builder.addCase(addReadyMadeProduct?.fulfilled, (state) => {
            state.loading = false
        })
        builder.addCase(addReadyMadeProduct?.rejected, (state, action) => {
            state.loading = false
            state.error = action?.error?.message ? action?.error?.message : 'Error in addReadyMadeProduct'
        })
    }
})

export default ReadymadeProductSlice?.reducer
